import { render, staticRenderFns } from "./comments-response.vue?vue&type=template&id=2e298359&scoped=true&"
import script from "./comments-response.vue?vue&type=script&lang=ts&"
export * from "./comments-response.vue?vue&type=script&lang=ts&"
import style0 from "./comments-response.vue?vue&type=style&index=0&id=2e298359&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e298359",
  null
  
)

export default component.exports